<div [formGroup]="form"  class="form-checkbox" [ngClass]="{'disabled': disabled}">
    <label class="checklabel">
    <input type="checkbox"
            [checked]="checked"
            (change)="toogleCheck()"
            [disabled]="disabled"
        /><span class="checkmark"></span>
    </label>
    <div class="selector-name">
      <span [innerHTML]="label" (click)="toogleCheck()"></span>
    </div>
</div>
